import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiLogOut, FiHome } from 'react-icons/fi';
import logoOctopus from '../../assets/images/logo.png';
import { useAuth } from '../../contexts/AuthContext';

// Importar iconos existentes
import clientesIcon from '../../assets/images/iconos/clientes.png';
import inventarioIcon from '../../assets/images/iconos/inventario.png';
import facturacionIcon from '../../assets/images/iconos/facturacion.png';
import proveedoresIcon from '../../assets/images/iconos/proveedores.png';
import productosIcon from '../../assets/images/iconos/productos.png';
import informesIcon from '../../assets/images/iconos/informes.png';
import ventasEstimadosIcon from '../../assets/images/iconos/ventas_estimados.png';

const Sidebar = ({ isOpen, onToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, hasPermission } = useAuth();

  // Módulos según la documentación e imagen proporcionada
  const modules = [
    {
      path: '/system',
      label: 'HOME',
      icon: informesIcon
    },
    {
      path: '/system/clientes',
      label: 'CLIENTES',
      icon: clientesIcon
    },
    {
      path: '/system/inventario',
      label: 'INVENTARIO',
      icon: inventarioIcon
    },
    {
      path: '/system/facturacion',
      label: 'FACTURACIÓN',
      icon: facturacionIcon
    },
    {
      path: '/system/ventas',
      label: 'TOMA DE ÓRDENES',
      icon: ventasEstimadosIcon
    },
    {
      path: '/system/proveedores',
      label: 'PROVEEDORES',
      icon: proveedoresIcon
    },
    {
      path: '/system/compras',
      label: 'ÓRDENES DE COMPRA',
      icon: facturacionIcon
    },
    {
      path: '/system/productos',
      label: 'PRODUCTOS',
      icon: productosIcon
    },
    {
      path: '/system/formulaciones',
      label: 'FORMULACIONES',
      icon: productosIcon
    },
    {
      path: '/system/procesos',
      label: 'REGISTRO DE PROCESOS',
      icon: informesIcon
    },
    {
      path: '/system/reportes',
      label: 'REPORTES',
      icon: informesIcon
    },
    {
      path: '/system/vendedores',
      label: 'VENDEDORES',
      icon: clientesIcon
    },
    {
      path: '/system/admin',
      label: 'ADMINISTRACIÓN',
      icon: clientesIcon,
      permission: 'manage_users' // Requiere permiso para gestionar usuarios o cualquier permiso de admin
    },
    {
      path: '/system/seguimiento',
      label: 'SEGUIMIENTO DE PROSPECTOS',
      icon: clientesIcon
    }
  ];

  // Filtrar módulos según permisos del usuario
  const visibleModules = modules.filter(module => {
    // Si el módulo no requiere permisos, mostrarlo
    if (!module.permission) return true;
    // Si requiere permiso, verificar que el usuario lo tenga
    return hasPermission(module.permission);
  });

  const isActive = (path) => {
    if (path === '/system') {
      return location.pathname === '/system' || location.pathname === '/system/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar__header">
          <div className="logo">
            <img src={logoOctopus} alt="Betel Natural" />
          </div>
          <div className="menu-title">Modulos</div>
        </div>

        <nav className="sidebar__nav">
          <ul className="nav-list">
            {visibleModules.map((module) => (
              <li key={module.path} className="nav-item">
                <Link
                  to={module.path}
                  className={`nav-link ${isActive(module.path) ? 'active' : ''}`}
                  style={{ textDecoration: 'none' }}
                  onClick={() => {
                    // En mobile, cerrar el sidebar al hacer click
                    if (window.innerWidth <= 767) {
                      onToggle();
                    }
                  }}
                >
                  <img 
                    src={module.icon} 
                    alt={module.label} 
                    className="nav-icon"
                    style={{ textDecoration: 'none' }}
                  />
                  <span 
                    className="nav-label"
                    style={{ textDecoration: 'none' }}
                  >
                    {module.label}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar__footer">
          <button 
            className="btn btn--ghost btn--small logout-button"
            onClick={() => {
              logout();
              navigate('/login');
            }}
            title="Cerrar Sesión"
          >
            <FiLogOut className="logout-icon" />
            <span className="logout-text">Cerrar Sesión</span>
          </button>         
        </div>
      </div>

      {/* Overlay para mobile */}
      <div 
        className={`mobile-overlay ${isOpen ? 'show' : ''}`}
        onClick={onToggle}
      />
    </>
  );
};

export default Sidebar;